import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { RouterModule } from '@angular/router';
import { MediaObserver } from '@ngbracket/ngx-layout';
import { Store } from '@ngxs/store';
import { Observable, distinctUntilChanged, map, withLatestFrom } from 'rxjs';
import { ToggleSidenav } from 'src/shared/state/main.action';
import { MainState } from '../../../shared/state/main.state';
import { HeaderComponent } from '../header/header.component';
import { MainMenuComponent } from '../main-menu/main-menu.component';

@Component({
	selector: 'app-tacit',
	templateUrl: './tacit.component.html',
	styleUrls: ['./tacit.component.scss'],
	imports: [
		CommonModule,
		HeaderComponent,
		MainMenuComponent,
		MatSidenavModule,
		RouterModule,
	],
})
export class TacitComponent implements OnInit {
	private mediaObserver = inject(MediaObserver);
	private store = inject(Store);

	sidenavOpened: Observable<boolean> = this.store.select(
		MainState.sidenavOpened
	);

	ngOnInit(): void {
		this.mediaObserver
			.asObservable()
			.pipe(
				map(() => this.mediaObserver.isActive('lt-md')),
				distinctUntilChanged(),
				withLatestFrom(this.store.select(MainState.sidenavOpened))
			)
			.subscribe(([isSmall, sidenavOpened]) => {
				if (isSmall && sidenavOpened) {
					this.store.dispatch([new ToggleSidenav()]);
				}
			});
	}
}
